<template>
  <el-card v-loading="loading">
    <div ref="scrollContainer" id="page-panel" >
      <!-- <resize-observer @notify="__resizeHanlder" /> -->

        <div class="customer-top-nav">
          <div class="title">
            <span>{{$t('reports.names.'+reportCode)}}</span><br>
          </div>
          <div class="controls no-print">
             <!-- <el-button @click="print" size="small"><i class="mdi mdi-printer"></i> Télécharger</el-button> -->
             <el-dropdown size="small" type="default" class="">
               <el-button type="primary" size="small">
                 <i class="el-icon-download"></i>
               </el-button>
               <el-dropdown-menu slot="dropdown">
                 <el-dropdown-item @click.native="downloadReport('pdf')"><i class="mdi mdi-file-pdf"/> PDF</el-dropdown-item>
                 <el-dropdown-item @click.native="downloadReport('csv')"><i class="mdi mdi-file-excel"/> CSV</el-dropdown-item>
                 <el-dropdown-item @click.native="downloadReport('QUICKBOOKS', true)"><i class="mdi mdi-file-excel"/> Export Quickbooks</el-dropdown-item>
               </el-dropdown-menu>
             </el-dropdown>
    				 <el-button type="primary" @click="openFilterDialog" size="small"><i class="mdi mdi-filter"></i> </el-button>
    			</div>
        </div>

        <p>
          <span class="fs-14 secondary-text">{{companyName}}</span><br>
          <span class="fs-14 secondary-text">{{currentFilterPeriod}}</span><br>
          <span class="fs-14 secondary-text" v-if="customerName!=null && customerName!='' && filters.customerId!=null">Client sélectionné : {{customerName}}</span>
          <span class="fs-14 secondary-text" v-else>Tous les clients</span>
        </p>
        <div id="printMe">
        <el-table :data="summary" :style="tableWidth" ref="summary">
          <el-table-column  align="left" :label="$t('reports.PAYMENTS.summary')">
            <template slot-scope="scope">
              <span class="fs-14" v-if="scope.row.header"><strong>{{$t('reports.PAYMENTS.headers.'+scope.row.name)}}</strong></span>
              <span class="fs-14 pl-20" v-else>{{$t('reports.PAYMENTS.headers.'+scope.row.name)}}</span>
            </template>
          </el-table-column>
          <el-table-column  align="right" >
            <template slot-scope="scope">
              <span class="fs-14"><strong>{{scope.row.total}} $</strong></span>
            </template>
          </el-table-column>
        </el-table>

        <h4>{{$t('reports.PAYMENTS.title')}}</h4>
        <span class="fs-14 secondary-text" v-if="selectedPaymentMethods!=null && selectedPaymentMethods!=''">Mode(s) de paiement sélectionné(s) : {{selectedPaymentMethods}}</span>
        <span class="fs-14 secondary-text" v-else>Mode(s) de paiement sélectionné(s) : Tous les modes de paiement</span>
        <el-divider/>
        <el-pagination
          :small="pagination.small"
          :current-page.sync="pagination.page"
          :page-sizes="pagination.sizes"
          :page-size.sync="pagination.size"
          :layout="pagination.layout"
          :total="totalRecords"
          :hide-on-single-page="true"
        ></el-pagination>
        <el-table :data="listInPage" :style="tableWidth" stripe empty-text="Il n'y a aucun paiement pour cette période">
          <el-table-column   label="Date" prop="date" sortable width="100">
            <template slot-scope="scope">
              <span class="fs-12">{{_moment(scope.row.date)}}</span>
            </template>
          </el-table-column>
          <el-table-column   label="Client" prop="customer.name" sortable :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <el-link :underline="false" @click="openCustomer(scope.row.customer.id)" type="primary"><span class="fs-12">{{(scope.row.customer.name)}}</span></el-link><el-link :href="'/customers/'+scope.row.customer.id" target="_blank" type="primary" :underline="false"><i class="mdi mdi-launch ml-10"></i></el-link>
            </template>
          </el-table-column>
          <el-table-column label="Mode" prop="type.code" sortable :show-overflow-tooltip="true" width="120">
            <template slot-scope="scope">
              <span class="fs-12">{{$t('invoices.'+scope.row.type.code)}}</span>
            </template>
          </el-table-column>
          <el-table-column   label="Reference/Description" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span class="fs-12">{{scope.row.payment_ref_number}}</span>
              <span class="fs-12">{{(scope.row.reference)}}</span><br>
              <span class="fs-12">{{(scope.row.description)}}</span>
            </template>
          </el-table-column>
          <el-table-column   label="Document(s)" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span v-for="(i,index) in scope.row.invoices" :key="index">
                <span v-if="index>0" class="fs-12">,</span>
                <el-link :underline="false" :href="'/invoices/'+i.id" type="primary"><span class="fs-12">{{i.inv_number}}</span></el-link> <el-link :href="'/invoices/'+i.id" target="_blank" type="primary" :underline="false"><i class="mdi mdi-launch ml-10"></i></el-link>
              </span>
              <span v-if="scope.row.credit_note!=null">
                <br>
                <PortausLink fs="fs-12" :id="scope.row.credit_note.id" path="/credit-notes/" :label="scope.row.credit_note.cr_number"></PortausLink>
                <span class="fs-12"> ({{$t('credit_notes.reasons.OVER_PAYMENT')}})</span>
              </span>
            </template>
          </el-table-column>
          <el-table-column   label="Montant" align="right" prop="amount" sortable width="150" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span class="fs-12">{{$n(scope.row.amount, 'currency', getCurrency(scope.row.invoices))}}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          :small="pagination.small"
          :current-page.sync="pagination.page"
          :page-sizes="pagination.sizes"
          :page-size.sync="pagination.size"
          :layout="pagination.layout"
          :total="totalRecords"
          :hide-on-single-page="true"
        ></el-pagination>
      </div>
      <reportFilter :visible="reportFilterVisible"
                    @close="closeFilterDialog"
                    :predefinedPeriod="predefinedPeriod"
                    :groups="groups"
                    :period="period"
                    :startDate="this.filters.startDate"
                    :endDate="this.filters.endDate"
                    :paymentMethods="paymentTypeCategories"
                    :methods="this.filters.methods"
                    :customerFilter="true"
                    :customer="selectedCustomer"
                    @applyFilter="handleFilter">
      </reportFilter>
    </div>
  </el-card>
</template>
<script>
//import Section
import salesAPI from '@/services/API/sales.js'
import systemAPI from '@/services/API/system.js'
import paymentAPI from '@/services/API/payment.js'
import moment from 'moment'
import reportFilter from './report-filter'
import reportUtil from '@/utils/report-util.js'
import PortausLink from '@/components/portaus-link'
import CustomerUtil from '@/utils/customer-util'
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
  name : "report-payments",
  props : {
    width : {
      type : Number,
      default : 100
    },
    fiscalEndDay : Number,
    fiscalEndMonth : Number,
    lastFiscalYearDate : Object,
    fiscalYearDate : Object,
    month : Object,
    lastMonth : Object,
    companyName : '',
  },
  data() {
    return {
      output : null,
      data : [],
      loading:true,
      totalPayments : 0.00,
      filters : {
        range : null,
        startDate : null,
        endDate : null,
        methods : [],
        customerId : null,
      },
      customerName : null,
      reportFilterVisible : false,
      pageWidth : null,
      pageHeight : null,
      pagination: {
        page: 1,
        size: 20,
        sizes: [10, 15, 20, 30, 50, 100],
        layout: 'total, ->, prev, pager, next, sizes',
        small: false
      },
    };
  },
  components : {
    reportFilter,
    PortausLink
  },
  computed : {
    getDataByPaymentType () {
      return _.groupBy(this.data, 'type.category.id');
    },
    getTotalByPaymentType () {
      const totalByType = [];
      _.forEach(this.paymentTypeCategories, type => {
        let total = 0;
        const data = this.getDataByPaymentType[type.id];
        _.forEach(data, d => {
          total = Math.round(((total + d.amount) * 100)) / 100;
        })
        totalByType.push({ id: type.id, code: type.code, total});
      })
      return totalByType;
    },
    selectedPaymentMethods(){
      let methods = '';
      if(this.filters.methods!=null & this.filters.methods.length>0){
        _.forEach(this.filters.methods, (m, index)=>{
          if(index>0)methods+=', ';
          let p = _.find(this.paymentTypeCategories, pm=>{return pm.id==m})
          if (p!= null) methods+=this.$i18n.t('invoices.'+p.code);

        })
      }
      return methods;
    },
    selectedCustomer(){
      if(this.filters.customerId!=null && this.filters.customerId!=undefined){
        return {id:this.filters.customerId}
      }else{
        return null;
      }
    },
    tableWidth(){
      return 'width : ' + this.width + 'px;';
    },
    currentFilterPeriod(){
      return reportUtil.currentFilterPeriod(this.fiscalYearDate,this.lastFiscalYearDate,this.filters.range,this.filters.startDate,this.filters.endDate )
    },
    predefinedPeriod(){
      if(this.fiscalYearDate.startDate!=null && this.fiscalYearDate.endDate!=null){
        return [
          {code : 'MONTH', description:this.month.startDate.format('DD MMM YYYY') + '-'+this.month.endDate.format('DD MMM YYYY')},
          {code : 'LAST_MONTH', description:this.lastMonth.startDate.format('DD MMM YYYY') + '-'+this.lastMonth.endDate.format('DD MMM YYYY')},
          {code : 'FISCAL_YEAR',description:this.fiscalYearDate.startDate.format('DD MMM YYYY') + '-'+this.fiscalYearDate.endDate.format('DD MMM YYYY')},
          {code : 'LAST_FISCAL_YEAR',description:this.lastFiscalYearDate.startDate.format('DD MMM YYYY') + '-'+this.lastFiscalYearDate.endDate.format('DD MMM YYYY')},
          {code : 'CUSTOM', range:true}
        ]
      }else{
        return [];
      }

    },
    period(){
      return _.find(this.predefinedPeriod, p=>{return p.code==this.filters.range})
    },
    groups(){
      return []
    },
    reportCode(){
      return this.$route.params.code;
    },
    total(){
      let total = 0.00;
      _.forEach(this.data, p=>{
        total+=p.amount;
      })
      return Math.round(total*100)/100;
    },
    summary(){
      let data = [
        {name:'summary', header:true, total:this.total}
      ]

      _.forEach(this.getTotalByPaymentType, totalByType => {
        const category = _.find(this.paymentTypeCategories, cat => cat.id === totalByType.id);
        data.push({ name: `category_${category.code}`, header:false, total: (totalByType.total).toFixed(2) })
      })

      return data;
    },
    usableData(){
      return this.data;
    },
    totalRecords() {
			return this.usableData.length
		},
    listInPage(){
      let from = (this.currentPage - 1) * this.itemPerPage
      let to = from + (this.itemPerPage*1)
      //return this.listSortered.slice(from, to)
      return this.usableData.slice(from, to)
    },
    currentPage: {
			get() {
				return this.pagination.page
			},
			set(val) {
				this.pagination.page = val
			}
		},
		itemPerPage() {
			return this.pagination.size
		},
    ...mapState('controlData',['paymentTypeCategories'])
  },
  methods : {
    getCurrency (invoices) {
      return _.get(_.head(invoices), 'currency.code');
    },
    downloadReport(format){
      this.downloading=true;
      let filters = _.cloneDeep(this.filters);
      if(filters.startDate!=null){
        filters.startDate = moment(filters.startDate).format('YYYY-MM-DD Z');
      }
      if(filters.endDate!=null){
        filters.endDate = moment(filters.endDate).add(1, 'days').format('YYYY-MM-DD Z');
      }
      // console.log(filters);
      if(filters.customerId!=null){
        filters.customerName = localStorage.payments_customerName;
      }


      filters.format=format

      let filename = 'PAYMENTS_REPORT_'+moment(this.filters.startDate).format('YYYY-MM-DD')+'-'+moment(this.filters.endDate).format('YYYY-MM-DD');
      filename+="."+format;

      if (format === 'QUICKBOOKS') {
        return paymentAPI.downloadQuickbooksExtractPaymentsCSV(filters, filename)
        .then(()=>{
          this.downloading=false;
        }).catch(err=>{
          this.downloading=false;
          this.$message.error("Oops... Une erreur est survenue!");
        })
      }

      return salesAPI.downloadSalesReport(this.reportCode, filename, filters);
    },
    openCustomer(customerId){
      var index='/customers/'+customerId;
			this.$router.push(index);
    },
    _moment(date, format='l'){
      return moment(date).format(format);
    },
    handleFilter(filters){
      localStorage.payments_groupBy=filters.group;
      localStorage.payments_range=filters.period.code;
      localStorage.payments_startDate = filters.dateRange[0];
      localStorage.payments_endDate = filters.dateRange[1];
      localStorage.payments_customerId = filters.customer!=null ? filters.customer.id : undefined;
      if(filters.customer!=null){
        localStorage.payments_customerName = CustomerUtil.customerName(filters.customer.name,filters.customer.usual_name);
      }
      let methods = [];
      _.forEach(filters.paymentMethods, m=>{
        methods.push(m.id);
      })
      localStorage.payments_methods = JSON.stringify(methods);
      this.setFilters();
      this.fetchData();
    },
    openFilterDialog(){
      this.reportFilterVisible = true;
    },
    closeFilterDialog(){
      this.reportFilterVisible=false;
    },
    getRealPeriodNumber(falseNumber){
      let number = falseNumber;
      if(falseNumber>12){
        number-=12;
      }
      return number;
    },
    showPeriodName(periodNumber){
      if(this.filters.groupBy=='MONTH'){
        return moment().month(this.getRealPeriodNumber(periodNumber)).format('MMM');
      }else{
        let realPeriodNumber= this.getRealPeriodNumber(periodNumber);
        let startMonth = moment().month(((realPeriodNumber+1)*3)-3).format('MMM');
        let endMonth = moment().month(((realPeriodNumber+1)*3)-1).format('MMM');
        return startMonth + '-' + endMonth
      }

    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
        if(row.span){
          return {rowspan:1, colspan:this.nbColums+2}
        }else{
          return {rowspan:1, colspan:1}
        }
      },

		setPageWidth() {
			this.pageWidth = document.getElementById('page-panel').offsetWidth;
			this.pageHeight = document.getElementById('page-panel').offsetHeight;
		},
    __resizeHanlder: _.throttle(function (e) {
  			this.setPageWidth();
  		}, 700),
    fetchData(format = null){
      this.loading = true;
      this.totalPayments = 0.00;
      let filters = _.cloneDeep(this.filters);
      var offset = moment().utcOffset();
      if(filters.startDate!=null){
        filters.startDate = moment(filters.startDate).format('YYYY-MM-DD Z');
      }
      if(filters.endDate!=null){
        filters.endDate = moment(filters.endDate).add(1, 'days').format('YYYY-MM-DD Z');
      }


      return salesAPI.getReportInfo(this.reportCode, filters)
        .then(data=>{
          this.data = data;
          this.loading = false;
        }).catch(err=>{
          console.log(err);
          this.loading = false;
          this.$message.error('Une erreur système est survenue. Veuillez réessayer plus tard')
        })
    },
    setFilters(){
      if(localStorage.payments_range==null){
        localStorage.payments_range='MONTH';
      }

      if(localStorage.payments_methods==null){
        localStorage.payments_methods=JSON.stringify([]);
      }

      this.customerName = localStorage.payments_customerName;

      this.filters.range=localStorage.payments_range;
      // console.log("localStorage.payments_customerId : ", localStorage.payments_customerId);
      this.filters.customerId=localStorage.payments_customerId!='undefined' && localStorage.payments_customerId!=null  ? parseInt(localStorage.payments_customerId) : undefined;
      this.filters.methods=JSON.parse(localStorage.payments_methods);

      if(this.filters.range=='FISCAL_YEAR' && this.fiscalYearDate.startDate!=null && this.fiscalYearDate.endDate!=null){
        localStorage.payments_startDate = this.fiscalYearDate.startDate;
        localStorage.payments_endDate = this.fiscalYearDate.endDate;
      }else if(this.filters.range=='LAST_FISCAL_YEAR' && this.lastFiscalYearDate.startDate!=null && this.lastFiscalYearDate.endDate!=null){
        localStorage.payments_startDate = this.lastFiscalYearDate.startDate;
        localStorage.payments_endDate = this.lastFiscalYearDate.endDate;
      }else if(this.filters.range=='MONTH'){
        localStorage.payments_startDate = this.month.startDate;
        localStorage.payments_endDate = this.month.endDate;
      }else if(this.filters.range=='LAST_MONTH'){
        localStorage.payments_startDate = this.lastMonth.startDate;
        localStorage.payments_endDate = this.lastMonth.endDate;
      }

      this.filters.startDate = localStorage.payments_startDate;
      this.filters.endDate = localStorage.payments_endDate;
    },
    ...mapActions('controlData',['fetchPaymentTypeCategories'])
  },
  mounted(){
    this.setPageWidth();
    this.$refs.summary.$options._parentVnode.elm.classList.remove('el-table--enable-row-hover')
  },
  created(){
    this.loading = true;
    this.setFilters();
    this.fetchPaymentTypeCategories();
    this.fetchData();
  },
  beforeDestroy(){
    this.data = [];
  }
}
</script>
<style lang="scss" scoped>
@import '../../../../../assets/scss/_variables';

@media print {
  body, html { margin-top:0%;
    font-size:0.8em;
     display:block;
     height:100%;
     width:100%;
     position:unset !important;
     background:none;
     overflow-x: hidden;overflow-y: auto;height:100%;width:100%;display:block;position:unset
   }
   .no-print{
   	display:none;
   }
   .el-card{
     border:none;
     width:100%;
   }

   @page {
     size: portrait;
   }


}



.title {
	font-size : 1.6em;
	font-weight:bold;
	margin-right:20px;
	position:relative;
	float:left;
}
.customer-top-nav{
  height:40px;
}

.controls{
	position:relative;
	float:right;

	button{
		margin-left:20px;
	}
}


</style>
